import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class Crater3PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.CRATER3;
}

export default Crater3PoiTileEntity;
